import NoOfNonCompliantStoresByKeyRetailer from "./NoOfNonCompliantStoresByKeyRetailer";
export default NoOfNonCompliantStoresByKeyRetailer;
